import { render, staticRenderFns } from "./LogoContainer.vue?vue&type=template&id=222d55a7&scoped=true&"
import script from "./LogoContainer.vue?vue&type=script&lang=js&"
export * from "./LogoContainer.vue?vue&type=script&lang=js&"
import style0 from "./LogoContainer.vue?vue&type=style&index=0&id=222d55a7&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222d55a7",
  null
  
)

export default component.exports